import React from 'react';
import { Block } from "@randajan/jet-react/dom/block";

import "./ContactPane.scss";
import { Article } from '../../../elements/Article/Article';
import { ImgStore } from '../../../elements/ImgStore/ImgStore';


export const ContactPane = (props) => {
    const { links } = props;

    return (
        <Block className="ContactPane">
            <div className="background">
                <ImgStore src={"bgContactPane"}/>
            </div>
            <div className="slab">
                <div className="webLinksSpacer">

                </div>
                <div className="contactCompany">
                    <Article storeId="contactCompany" />
                </div>
            </div>

        </Block>
    )
}

